import React, { useEffect, useRef, useState } from "react";
import { Form } from "antd";
import { useNavigate } from "react-router-dom";
import _ from "lodash";

import HexLoader from "../../../../components/HexLoader";
import { metaData } from "../../meta-data";
import { formDataFields } from "../../formData";
import { getUpdatedData, profileFormPatch } from "../../hooks/use-helpers";
import useProfile from "../../../../features/profile/useProfile";
import { getSubmissionData } from "../../hooks/info-form-helper";
import RegistrationLayout from "../../../Main/RegistrationLayout";
import Notification from "../../../../components/Notification";
import HexButton from "../../../../ui-kit/HexButtons";
import AvatarListing from "../../../../components/AvatarListing";
import FormFactory from "../../../../components/FormFactory";
import RegistrationTemplate from "../../../../components/RegistrationTemplate";
import {
  getDeviceId,
  getStorageItem,
  handleError,
  removeLocalStorageItems,
  saveDeviceId,
  showSuccessMessage,
} from "../../../../utils/common-utils";

import "../../styles.css";
import "../../theme.css";
import { getLabel } from "../../../../hooks/use-labels";

const ProfileInfo = ({
  onDraftChange,
  showAddressView,
  addressDetails,
  profileDetails,
  submitted,
  addressLiner,
}) => {
  const navigate = useNavigate();
  const infoAvatarList = metaData()["info"];
  const { options } = infoAvatarList;

  const profileInfo = formDataFields(submitted)["info"];

  const { title, subTitle, text, footerText, fields, formHandler } =
    profileInfo;

  const profileInfoConfig = {
    title: title,
    subTitle: subTitle,
    footerText,
  };

  const { saveProfile, error: saveError } = useProfile();

  const [form] = Form.useForm();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formFields, setFormFields] = useState(fields);
  const [notification, setNotification] = useState("");
  const [addressRequire, setAddressRequire] = useState("");

  const dirty = useRef(false);

  useEffect(() => {
    if (dirty.current) return;
    if (!_.isEmpty(profileDetails)) {
      setFormFields(profileDetails);
    }
  }, [profileDetails]);

  const onChangeHandler = (value, key) => {
    dirty.current = true;

    const requestData = {
      type: formHandler,
      value,
      key,
      formFields,
    };

    getUpdatedData(requestData, (data) => {
      const { updatedFields } = data;
      const updatedErrors = { ...errors };
      updatedErrors[key] = "";

      setErrors(updatedErrors);
      setFormFields(updatedFields);
    });
  };

  const formSubmitDataHandler = () => {
    const { required, fieldsData } = getSubmissionData(formFields);

    if (!_.isEmpty(required)) {
      setErrors(required);
    } else {
      if (_.isEmpty(addressDetails)) {
        setAddressRequire("required");
      } else {
        onSubmit(fieldsData);
      }
    }
  };

  const moveToHomePage = () => {
    const redirectPath = getStorageItem("redirectPath");

    if (redirectPath) {
      const { path, state } = redirectPath;

      navigate(path, { ...(state && { state }) });
    } else {
      removeLocalStorageItems("marker-location");
      navigate("/");
    }
  };


  const onSubmit = async (profileData) => {
    const patch = profileFormPatch(profileData, addressDetails, submitted);
    setLoading(true);
    setNotification("");

    const ok = await saveProfile(patch);

    setLoading(false);

    if (ok) {
      dirty.current = false;
      onDraftChange(null);
    }

    if (!ok) {
      setNotification(saveError || handleError(new Error("save failed")));
      return;
    }

    removeLocalStorageItems("phoneNumber");

    const deviceId = getDeviceId();
    !deviceId && saveDeviceId();

    if (!submitted) {
      moveToHomePage();
    } else {
      showSuccessMessage(getLabel("updateProfileMessage"));
    }
  };

  const onAvatarItemClick = (link) => {
    if (link) {
      onDraftChange(formFields);
      showAddressView();
    }
  };

  return (
    <RegistrationLayout className="profile-layout business">
      <RegistrationTemplate
        containerName="business"
        sectionName={"info"}
        configs={profileInfoConfig}
        headerLogo={false}
        goBack={true}
        footerLogo={true}
      >
        <div className="business__listing">
          <Form
            layout="vertical"
            form={form}
            onFinish={formSubmitDataHandler}
            className="sapphire-webapp-form-container"
          >
            <FormFactory
              formElementsTypes={formFields}
              onChangeHandler={onChangeHandler}
              errors={errors}
            />
          </Form>
          <AvatarListing
            options={options}
            onListItemClick={(link) => onAvatarItemClick(link)}
            optionValueList={[addressLiner]}
          />
          {addressRequire && (
            <div className="notification-content notification-required">
              {addressRequire}
            </div>
          )}
        </div>

        {notification && <Notification type="danger" message={notification} />}
        {loading ? (
          <HexLoader />
        ) : (
          <div className="business__btn">
            <HexButton
              label={text}
              onClick={() => form.submit()}
              type="primary"
              size="lg"
              htmlType="submit"
              html
            />
          </div>
        )}
      </RegistrationTemplate>
    </RegistrationLayout>
  );
};

export default ProfileInfo;
